import BigButton from '../../globals/buttons/BigButton';
import { Plan } from 'data/pages/Home/PricingData';

function PricingCard({ type, img, price, pack }: Plan) {
  return (
    <>
      <div className="flex flex-col w-1/3 md1000:w-[40rem] bg-white shadow-xl relative min540:w-[100%]">
        <div
          style={{ transition: 'all 0.3s' }}
          className="relative grayscale hover:grayscale-0"
        >
          <img src={img} alt="pricing_img" className="w-full h-full" />
          <div className="absolute bg-white text-[20px] font-bold w-[25rem] text-center py-6 text-[#ff0336] -bottom-[18px] left-0 right-0 mx-auto">
            {type}
          </div>
        </div>
        <div className="flex flex-col items-center pt-[20px] pb-[50px]">
          <p className="text-center text-[55px] font-bold relative py-[10px] ">
            <span className="text-[30px] text-[#6d6d6d] absolute font-normal top-8 -left-[3rem]">
              $
            </span>
            {price}
            <span className="text-[22px] text-[#6d6d6d] absolute font-normal bottom-[25px] -right-[6rem]">
              p/m
            </span>
          </p>

          <div className="flex flex-col text-[16px] font-medium text-center gap-8 text-[#646464] h-[200px] overflow-y-auto">
            {pack.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>

          <BigButton
            color={`!text-white`}
            bg={`bg-[#ff0336]`}
            text="purchase now"
            cN="pricing-cta"
            goTo="/contact"
          />
        </div>
      </div>
    </>
  );
}

export default PricingCard;
